module.exports = __webpack_public_path__ + "img/facebook_social.60a4318d.svg";